import axios from 'axios';
import {getTenantIdFromToken, getToken, isValidSession} from "./session";

const getStoredUser = () => {
    try {
        const rawUser = localStorage.getItem('userLogged');
        return rawUser ? JSON.parse(rawUser) : null;
    } catch {
        return null;
    }
};

const getTenantId = (user) => (
    user?.tenantId
    || user?.tenant_id
    || user?.tenant?.id
    || user?.tenant?.tenantId
    || user?.context?.tenantId
    || user?.context?.tenant_id
    || null
);

const getCompanyId = (user) => (
    user?.companyId
    || user?.company_id
    || user?.company?.id
    || user?.empresa?.id
    || user?.context?.companyId
    || user?.context?.company_id
    || null
);

/**
 * Instância base da API.
 *
 * Aqui você pode alterar a URL conforme o ambiente:
 * - DEV: http://localhost:3000/api
 * - HOM/PROD: usar variável de ambiente import.meta.env.VITE_API_URL
 */
export const api = axios.create({
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 10000,
});

// Interceptor para incluir JWT automaticamente
api.interceptors.request.use(
    (config) => {
        const userLogged = getStoredUser();
        const token = getToken(userLogged);
        if (token && isValidSession(userLogged)) {
            config.headers.Authorization = `Bearer ${token}`;
            // `tenantId`, e não `x-tenant-id`: o authorizer lê os dois, mas o identity, por
            // dentro, só lê este.
            const tenantId = getTenantId(userLogged) || getTenantIdFromToken(token);
            const companyId = getCompanyId(userLogged);
            if (tenantId) config.headers.tenantId = tenantId;
            if (companyId) config.headers.companyId = companyId;
        } else if (token) {
            localStorage.removeItem('userLogged');
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Interceptor para tratar erros globais
api.interceptors.response.use(
    (response) => response,
    (error) => {
        console.log(`Response Error: ${error}`);
        if (error.response?.status === 401) {
            localStorage.removeItem('userLogged');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);
